var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"s-footer"},[_vm._v(" We are not affiliated, associated, authorized, endorsed by, or in any way officially connected with SIDEARM Sports, or any of its subsidiaries or its affiliates. ")])}
var staticRenderFns = []

export { render, staticRenderFns }